const testimonials = [
  {
    quote:
      "We ran 1,200 interviews in the first batch itself. The students were genuinely surprised by how real it felt, the AI pushes back, asks follow-ups, and doesn't let you get away with vague answers.",
    name: 'Placement Director',
    org: 'Partner University',
  },
  {
    quote:
      "Most tools only do DSA. With Learn41, our students practiced system design, case studies, and behavioral rounds, all tailored to the companies actually coming to our campus.",
    name: 'Career Services Lead',
    org: 'Partner Institution',
  },
  {
    quote:
      "I prepared for my Amazon interview using Learn41. The feedback wasn't just 'do better', it told me exactly how Amazon evaluates and where I was falling short. Got the offer.",
    name: 'Final Year Student',
    org: 'CS Engineering',
  },
];

export default function Testimonials() {
  return (
    <section className="bg-primary py-20">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="font-playfair text-3xl md:text-5xl font-medium italic text-primary-foreground text-center mb-14">
          What people are saying
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-primary-800/50 rounded-2xl p-8 border border-primary-700/50"
            >
              <p className="text-primary-200 leading-relaxed mb-6 italic">
                "{t.quote}"
              </p>
              <div>
                <p className="text-primary-foreground font-semibold text-sm">{t.name}</p>
                <p className="text-primary-400 text-sm">{t.org}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
